import { render, staticRenderFns } from "./ConversationList.vue?vue&type=template&id=287dafc3&scoped=true"
import script from "./ConversationList.vue?vue&type=script&lang=js"
export * from "./ConversationList.vue?vue&type=script&lang=js"
import style0 from "./ConversationList.vue?vue&type=style&index=0&id=287dafc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287dafc3",
  null
  
)

export default component.exports